import { createApi } from '@reduxjs/toolkit/query/react';
import { backendBaseQuery } from '@shared/api';
import { EventGroup } from '../model';

export const eventsApi = createApi({
  reducerPath: 'events-api',
  baseQuery: backendBaseQuery,
  tagTypes: ['Event'],
  endpoints: (build) => ({
    getAvailableEvents: build.query<EventGroup[], void>({
      query: () => ({
        url: 'events',
        method: 'GET'
      }),
      providesTags: ['Event']
    }),
  })
});

export const {
  useGetAvailableEventsQuery,
} = eventsApi; 